import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../../Redux/userSlice";
import { showError, showSuccess } from "../../Redux/alertSlice";
import FormLayout from "../../components/FormLayout/FormLayout";
import PasswordInput from "../../components/Atoms/password/PasswordInput";
import { CiLock } from "react-icons/ci";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { loading, error } = useSelector((state) => state.authSlice || {});

  const [fields, setFields] = useState({
    password: "",
    confirmPassword: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const tokenFromUrl = new URLSearchParams(location.search).get("token");

  useEffect(() => {
    if (!tokenFromUrl) {
      navigate("/error");
    }
  }, [tokenFromUrl, navigate]);

  const validateFields = () => {
    const errors = {};
    const { password, confirmPassword } = fields;

    if (!password) {
      errors.password = "Enter password";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters long.";
    }

    if (!confirmPassword) {
      errors.confirmPassword = "Confirm your password";
    } else if (password !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match.";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;
    try {
      const result = await dispatch(
        resetPassword({
          password: fields.password,
          confirmPassword: fields.confirmPassword,
          token: tokenFromUrl,
        })
      ).unwrap();
      dispatch(showSuccess(result.message || "Password reset successfully"));
      navigate("/login");
    } catch (err) {
      const message = err?.message || "Failed to reset password";
      dispatch(showError(message));
    }
  };

  return (
    <FormLayout
      title="Set New Password"
      subTitle="New Password should be unique."
      buttonText={loading ? "Loading..." : "Set Password"}
      onSubmit={handleSubmit}
      linkTo=""
    >
      <div className="flex flex-col space-y-4">
        <PasswordInput
          id="password"
          name="password"
          label="New Password"
          value={fields.password}
          placeholder="Enter your new password"
          icon={CiLock}
          onChange={handleInputChange}
          errorMessage={formErrors.password}
        />
        <PasswordInput
          id="confirmPassword"
          name="confirmPassword"
          label="Confirm New Password"
          value={fields.confirmPassword}
          placeholder="Enter your new confirm password"
          icon={CiLock}
          onChange={handleInputChange}
          errorMessage={formErrors.confirmPassword}
        />
        {error && <p className="text-red-500">{error}</p>}
      </div>
    </FormLayout>
  );
};

export default ResetPassword;
